<div class="dialog-header" [class.shadow]="hasScrolled">
  <h2>{{ isEditMode ? 'Endereço' : 'Adicionar endereço' }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon svgIcon="close-current"> </mat-icon>
  </button>
</div>

<mat-dialog-content #dialogScrollArea>
  <form [formGroup]="addressDataForm">
    <!-- dados do contato -->
    <spe-titulo-sessao titulo="Dados do contato" icone="assets/icones/cinza/usuarios.svg"></spe-titulo-sessao>

    <mat-form-field
      
      [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.responsible)"
    >
      <mat-label>Responsável pelo recebimento dos benefícios </mat-label>
      <input id="first-field" matInput type="text" formControlName="responsible" />
      <mat-error>{{ validatorErrors(addressDataFormControl.responsible, submitted) }}</mat-error>
    </mat-form-field>

    <!-- endereço -->
    <spe-titulo-sessao titulo="Endereço" icone="assets/icones/cinza/enderecos.svg"></spe-titulo-sessao>

    <mat-form-field
      
      [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.addressType)"
    >
      <mat-label>Tipo de endereço</mat-label>
      <mat-select name="listAddressType" formControlName="addressType">
        <mat-option *ngFor="let element of listAddressType" [value]="element.value">
          {{ element.viewValue }}
        </mat-option>
      </mat-select>
      <mat-icon matSuffix class="color-brand-principal">keyboard_arrow_down</mat-icon>
      <mat-error>{{ validatorErrors(addressDataFormControl.addressType, submitted) }}</mat-error>
    </mat-form-field>

    <div class="d-flex align-items-center gap-3">
      <mat-form-field
        
        [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.zipCode)"
      >
        <mat-label>CEP</mat-label>
        <input matInput type="text" placeholder="Ex: 00000-000" mask="00000-000" formControlName="zipCode" />
        <!-- <mat-error>{{ validatorErrors(addressDataFormControl.zipCode, submitted) }}</mat-error> -->
      </mat-form-field>

      <button class="mb-24" type="button" mat-button (click)="findMethod()">Localizar</button>
    </div>

    <div *ngIf="showFields">
      <mat-form-field
        
        [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.street)"
      >
        <mat-label>Endereço</mat-label>
        <input matInput type="text" formControlName="street" />
        <mat-error>{{ validatorErrors(addressDataFormControl.street, submitted) }}</mat-error>
      </mat-form-field>

      <mat-form-field
        
        [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.number)"
      >
        <mat-label>Número </mat-label>
        <input matInput type="text" formControlName="number" maxlength="10" />
        <mat-error>{{ validatorErrors(addressDataFormControl.number, submitted) }}</mat-error>
      </mat-form-field>

      <mat-form-field
        [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.complement)"
        
      >
        <mat-label>Complemento</mat-label>
        <input matInput formControlName="complement" placeholder="Complemento (opcional)" />
      </mat-form-field>

      <mat-form-field
        [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.reference)"
        
      >
        <mat-label>Ponto de Referência</mat-label>
        <input matInput formControlName="reference" placeholder="Referência (opcional)" />
      </mat-form-field>

      <mat-form-field
        
        [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.district)"
      >
        <mat-label>Bairro</mat-label>
        <input matInput type="text" required formControlName="district" />
        <mat-error>{{ validatorErrors(addressDataFormControl.district, submitted) }}</mat-error>
      </mat-form-field>

      <div class="d-flex justify-content-between gap-3">
        <mat-form-field
          
          class="flex-fill"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.city)"
        >
          <mat-label>Cidade</mat-label>
          <input matInput type="text" required formControlName="city" />
          <mat-error>{{ validatorErrors(addressDataFormControl.city, submitted) }}</mat-error>
        </mat-form-field>

        <mat-form-field
          
          class="flex-fill"
          [ngClass]="commonService.switchMatErrorClassResponsivity(addressDataFormControl.state)"
        >
          <mat-label>Estado </mat-label>
          <input matInput type="text" required formControlName="state" />
          <mat-error>{{ validatorErrors(addressDataFormControl.state, submitted) }}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex gap-2">
  <button
    *ngIf="isEditMode"
    mat-icon-button
    [disabled]="desabilitarApagar"
    class="me-auto color-brand-principal"
    (click)="onDelete()"
    matTooltip="Excluir"
    matTooltipPosition="above"
  >
    <mat-icon svgIcon="lixo-current"></mat-icon>
  </button>
  <button mat-button (click)="onCancel()">Cancelar</button>

  <button mat-flat-button [disabled]="!addressDataForm.valid" (click)="onSave()">Salvar</button>
</mat-dialog-actions>
